import styled from "styled-components";
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";
import {SearchInputArenaDefaultMobileBox, SearchInputArenaDefaultPCBox} from "./search-input-area.default.box";

const SearchInputAreaDelawareParkPCBox = styled(SearchInputArenaDefaultPCBox)`
    border: 2px solid ${props => props.theme.colors.backgroundLight};
`;

export const SearchInputAreaDelawareParkBox = styledByDevice(SearchInputAreaDelawareParkPCBox, SearchInputArenaDefaultMobileBox);
